import { t } from "../lib/i18n";
import React from 'react';
import { CalendarView } from './CalendarView';

const CalendarViewWrapper: React.FC = () => {
    return (
        <div className="container mx-auto p-4 bg-bg-primary min-h-screen">
            <h1 className="text-2xl font-bold mb-4 text-text-secondary">{t("calendarViewWrapper.k1")}</h1>
            <div className="bg-bg-secondary p-4 rounded shadow border border-border-primary">
                <CalendarView />
            </div>
        </div>
    );
};

export default CalendarViewWrapper;
